/**
 * Web Font Loader
 * 
 * Dynamically injects @font-face CSS rules for custom fonts on web.
 * This approach works with webpack's asset resolution.
 */

// Import font files - webpack will resolve these to the correct URLs
import PlusJakartaSansRegular from '../../assets/fonts/Plus_Jakarta_Sans/static/PlusJakartaSans-Regular.ttf';
import PlusJakartaSansBold from '../../assets/fonts/Plus_Jakarta_Sans/static/PlusJakartaSans-Bold.ttf';
import RobotoCondensedRegular from '../../assets/fonts/Roboto_Condensed/static/RobotoCondensed-Regular.ttf';
import RobotoCondensedMedium from '../../assets/fonts/Roboto_Condensed/static/RobotoCondensed-Medium.ttf';
import RobotoCondensedBold from '../../assets/fonts/Roboto_Condensed/static/RobotoCondensed-Bold.ttf';

const fontDefinitions = [
  {
    fontFamily: 'PlusJakartaSans-Regular',
    src: PlusJakartaSansRegular,
    fontWeight: 400,
  },
  {
    fontFamily: 'PlusJakartaSans-Bold',
    src: PlusJakartaSansBold,
    fontWeight: 700,
  },
  {
    fontFamily: 'RobotoCondensed-Regular',
    src: RobotoCondensedRegular,
    fontWeight: 400,
  },
  {
    fontFamily: 'RobotoCondensed-Medium',
    src: RobotoCondensedMedium,
    fontWeight: 500,
  },
  {
    fontFamily: 'RobotoCondensed-Bold',
    src: RobotoCondensedBold,
    fontWeight: 700,
  },
];

/**
 * Injects @font-face CSS rules into the document head
 */
export function loadWebFonts() {
  if (typeof document === 'undefined') return;

  // Check if fonts are already loaded
  if (document.getElementById('meander-web-fonts')) return;

  const css = fontDefinitions
    .map(
      (font) => `
@font-face {
  font-family: '${font.fontFamily}';
  src: url('${font.src}') format('truetype');
  font-weight: ${font.fontWeight};
  font-style: normal;
  font-display: swap;
}
`
    )
    .join('\n');

  const style = document.createElement('style');
  style.id = 'meander-web-fonts';
  style.textContent = css;
  document.head.appendChild(style);

  console.log('[WebFontLoader] Custom fonts injected');
}

export default loadWebFonts;

